<template>
  <div class="Container">
    <Nav />
    <Side />
    <router-view></router-view>
  </div>
</template>

<script>
// @ is an alias to /src
import Side from '@/components/Side'
import Nav from '@/components/Nav'
import User from '@/components/Users'
import UserDetail from '@/components/DetailUser'
import Reservation from '@/components/Reservation'
import Stylelist from '@/components/Stylists'
import Service from '@/components/Services'
import Code from '@/components/Codes'
import Push from '@/components/Push'
import Report from '@/components/Reports'

export default {
  name: 'Container',
  components: {
    Side,
    Nav,
    User,
    Reservation,
    Stylelist,
    Service,
    Code,
    Push,
    Report
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*
* Animation
*/

.slide-fade-init-enter-active {
  transition: all 1s ease;
}

.slide-fade-init-enter, .slide-fade-init-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>